import { Priority } from './../model/interfaces';

export type Roles = {[K in Priority]: string}

export const Roles: Roles = {
  D: '(TD)',
  V: '(VIP)',
  M: '(moderator)',
  U: ''
}

export const RolesForPosts: Roles = {
  D: 'Tourney Director',
  V: 'VIP',
  M: 'Moderator',
  U: ''
}